import React from 'react';
import { ShieldCheckIcon, GraduationCapIcon, UsersIcon, GlobeIcon, CheckIcon } from 'lucide-react';
const plans = [{
  name: 'Effy Kids',
  price: 15,
  description: 'Parental safeguards, zero data overages, live GPS tracking hooks.',
  icon: ShieldCheckIcon,
  features: ['GPS Location Hooks', 'Safe-Search Matrix', 'Zero Overages'],
  color: '#FFF200'
}, {
  name: 'Effy Student',
  price: 25,
  description: 'Campus high-volume data pools, international messaging matrices.',
  icon: GraduationCapIcon,
  features: ['Campus Data Priority', 'Global SMS Matrix', 'Study-Mode AI'],
  color: '#00FF66'
}, {
  name: 'Effy Family',
  price: 80,
  description: 'Shared 5G pool, free eSIM swappings, unified group billing.',
  icon: UsersIcon,
  features: ['4 Lines Included', 'Shared 5G Pool', 'Unified Billing'],
  color: '#FF3366',
  highlight: true
}, {
  name: 'Solo Softphone',
  price: 10,
  description: 'Pure software profile for immigrants. Dial US family over WebRTC.',
  icon: GlobeIcon,
  features: ['Zero Hardware Needed', 'WebRTC Native', 'Instant Activation'],
  color: '#00FF66'
}];
export function FamilyPlans() {
  return <section id="plans" className="py-20 bg-gray-50" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <h2 className="text-5xl font-black tracking-tighter text-black mb-4 uppercase italic" data-id="element-107">
            Effy <span className="text-[#13E200]" data-id="element-108">Plans</span>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto font-bold uppercase tracking-widest text-xs leading-relaxed" data-id="element-109">
            Simple, affordable wireless for everyone.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-110">
          {plans.map((plan, i) => <div key={i} className={`bg-white rounded-2xl p-8 border-2 transition-all flex flex-col ${plan.highlight ? 'border-[#13E200] shadow-lg scale-105 z-10' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-111">
              <div className="mb-6" data-id="element-112">
                <div className="w-10 h-10 rounded-full flex items-center justify-center mb-4 bg-gray-50" style={{
              color: plan.highlight ? '#13E200' : '#333'
            }} data-id="element-113">
                  <plan.icon className="w-5 h-5" data-id="element-114" />
                </div>
                <h3 className="text-xl font-black text-black tracking-tighter mb-1 uppercase" data-id="element-115">
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1 mb-4" data-id="element-116">
                  <span className="text-4xl font-black text-black" data-id="element-117">
                    ${plan.price}
                  </span>
                  <span className="text-gray-400 text-[10px] font-black uppercase tracking-widest" data-id="element-118">
                    /mo
                  </span>
                </div>
                <p className="text-gray-500 text-xs font-bold leading-relaxed h-12 overflow-hidden uppercase tracking-wider" data-id="element-119">
                  {plan.description}
                </p>
              </div>

              <div className="space-y-3 mb-8 flex-1 border-t border-gray-50 pt-6" data-id="element-120">
                {plan.features.map((feature, j) => <div key={j} className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-gray-600" data-id="element-121">
                    <CheckIcon className="w-3 h-3 text-[#13E200]" data-id="element-122" />
                    {feature}
                  </div>)}
              </div>

              <button className={`w-full py-3 rounded-full font-black text-xs uppercase tracking-widest transition-all ${plan.highlight ? 'bg-[#13E200] text-black hover:bg-[#008A00]' : 'bg-black text-white hover:bg-gray-800'}`} data-id="element-123">
                Get Started
              </button>
            </div>)}
        </div>
      </div>
    </section>;
}